import { ApiResponse } from "../models/api-response";
import { callApi } from "./api.service";
import { PsychometricTest, PsychometricTestDetail } from "../types/exam-config.types";

const apiServerUrl = import.meta.env.VITE_API_SERVER_URL;

export interface PsychometricConfigResult {
  config_data: Record<string, unknown>;
  version: number;
}

/**
 * List all available psychometric tests from the test bank.
 */
export const listPsychometricTests = async (
  accessToken: string,
): Promise<ApiResponse<PsychometricTest[]>> => {
  return callApi<PsychometricTest[]>(`${apiServerUrl}/api/psychometric-tests`, {
    method: "GET",
    headers: {
      Authorization: `Bearer ${accessToken}`,
    },
  });
};

/**
 * Get a single psychometric test with full questions_data for preview.
 */
export const getPsychometricTestDetail = async (
  accessToken: string,
  testId: string,
): Promise<ApiResponse<PsychometricTestDetail>> => {
  return callApi<PsychometricTestDetail>(
    `${apiServerUrl}/api/psychometric-tests/${testId}`,
    {
      method: "GET",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );
};

/**
 * Add a psychometric test section to the exam config for a job.
 * Idempotent: adding the same test twice has no effect.
 */
export const addPsychometricSection = async (
  accessToken: string,
  jobId: string,
  testId: string,
): Promise<ApiResponse<PsychometricConfigResult>> => {
  return callApi<PsychometricConfigResult>(
    `${apiServerUrl}/api/offers/${jobId}/exam-config/psychometric-sections`,
    {
      method: "POST",
      headers: {
        Authorization: `Bearer ${accessToken}`,
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ test_id: testId }),
    },
  );
};

/**
 * Remove a psychometric test section from the exam config for a job.
 * Idempotent: removing a non-existent test returns success.
 */
export const removePsychometricSection = async (
  accessToken: string,
  jobId: string,
  testId: string,
): Promise<ApiResponse<PsychometricConfigResult>> => {
  return callApi<PsychometricConfigResult>(
    `${apiServerUrl}/api/offers/${jobId}/exam-config/psychometric-sections/${testId}`,
    {
      method: "DELETE",
      headers: {
        Authorization: `Bearer ${accessToken}`,
      },
    },
  );
};
